import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import api from "../../api/api";
import { BsFillCheckCircleFill, BsFillXCircleFill } from "react-icons/bs";

const ModalDeleteProject = ({
  modalDeleteProject,
  toggleModalDeleteProject,
  modalDeleteContent,
  setModalDeleteContent,
  updateList,
}) => {
  const deleteProject = async (id) => {
    try {
      setModalDeleteContent({
        ...modalDeleteContent,
        body: "Apagando projeto...",
        footer: false,
      });

      await api.put(`/projects/${id}/set-being-deleted`);
      await api.delete(`/projects/${id}`);

      setModalDeleteContent({
        ...modalDeleteContent,
        icon: <BsFillCheckCircleFill />,
        body: "Projeto apagado com sucesso.",
        footer: false,
      });
    } catch (error) {
      console.error("Error deleting project:", error);
      setModalDeleteContent({
        ...modalDeleteContent,
        icon: <BsFillXCircleFill />,
        body: "Não foi possível apagar o projeto.",
        footer: false,
      });
    } finally {
      updateList();
    }
  };

  return (
    <Modal
      isOpen={modalDeleteProject}
      toggle={toggleModalDeleteProject}
      // centered
      backdrop="static"
    >
      <ModalHeader toggle={toggleModalDeleteProject}>
        <div className="row m-0">
          <div className="col-2 m-auto">
            {modalDeleteContent.icon ? modalDeleteContent.icon : ""}
          </div>
          <div className="col m-auto">
            {modalDeleteContent.title ? modalDeleteContent.title : ""}
          </div>
        </div>
      </ModalHeader>
      <ModalBody>
        {modalDeleteContent.body ? modalDeleteContent.body : ""}
      </ModalBody>
      {modalDeleteContent.footer ? (
        <ModalFooter>
          <Button color="secondary" onClick={toggleModalDeleteProject}>
            Cancelar
          </Button>
          <Button
            color="danger"
            onClick={() => deleteProject(modalDeleteContent.idProject)}
          >
            Apagar
          </Button>
        </ModalFooter>
      ) : (
        ""
      )}
    </Modal>
  );
};

export default ModalDeleteProject;
